<template>
  <div class="battery-swap-edit">
    <div class="row">
      <div class="label">{{ $t('lang.Equipment number') }}</div>
      <div class="row-right">
        {{ deviceInfo.primaryDeviceNo }}
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Equipment type') }}</div>
      <div class="row-right">
        {{ deviceInfo.type }}
      </div>
    </div>
    <div class="row">

      <span style="color:red">*</span>
      <div class="label">{{ $t('lang.Equipment name') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="deviceInfo.deviceName"
                  clearable maxlength="50"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Equipment qr code') }}</div>
      <div class="row-right">
        {{ deviceInfo.qrCode }}
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Communication board number') }}</div>
      <div class="row-right">
        {{ deviceInfo.communicationBoardNo }}
      </div>
    </div>
    <!-- <div class="row">
        <div class="label">{{$t('lang.Location address')}}</div>
        <div class="row-right">
            <el-input class="fixed-width-200" type="text" v-model="deviceInfo.location" readonly ></el-input>
            <i class="el-icon-location-outline icon"></i>
        </div>
    </div> -->
    <div class="row">
      <span style="color:red">*</span>
      <div class="label">{{ $t('lang.Delivery address') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="placingPosition.join('/')" readonly></el-input>
        <i class="el-icon-location-outline icon" @click="dialogFormVisible = true"></i>
      </div>
    </div>
    <el-dialog :title="$t('lang.Please select the delivery address')" :visible.sync="dialogFormVisible">
      <!-- <el-amap-search-box
          class="search-box"
          :default="placingPosition[2]"
          :search-option="searchOption"
          :on-search-result="onSearchResult"
      ></el-amap-search-box> -->
      <div class="df googleInp">
        <el-input placeholder="" v-model="address" class="mr20" clearable></el-input>
        <el-button type="primary" @click="googleChange">搜索</el-button>
      </div>
      <div class="amap-page-container">
        <GmapMap
          :center="center"
          :zoom="zoom"
          map-type-id="roadmap"
          style="width: 100%; height: 300px"
          @click="events"
        >
          <GmapMarker
            :position="position"
            :clickable="true"
            :draggable="true"
          />
        </GmapMap>
        <!-- <el-amap
            vid="amapDemo"
            :center="center"
            :zoom="zoom"
            class="amap-demo"
            :events="events">
            <el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position"
                            :events="marker.events" :visible="marker.visible" :draggable="marker.draggable"
                            :vid="index"></el-amap-marker>
        </el-amap> -->
        <div class="toolbar">
          {{ $t('lang.selected location') }}:{{ address }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelChoose">{{ $t('lang.Cancel') }}</el-button>
        <el-button type="primary" @click="confirmChoose">{{ $t('lang.Confirm') }}</el-button>
      </div>
    </el-dialog>
    <div class="row">
      <div class="label">{{ $t('lang.Detailed address') }}</div>
      <div class="row-right">
        <el-input class="fixed-width-450"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  :placeholder="$t('lang.Please enter the detailed address')" v-model="detailAddress"
                  clearable maxlength="50">
        </el-input>
      </div>
    </div>
    <div class="row">
      <span style="color:red">*</span>
      <div class="label">{{ $t('lang.Replaceable battery spec') }}</div>
      <div class="row-right">
        <el-radio-group v-model="supportBatteryVoltageList">
          <el-radio :label='48'>48V</el-radio>
          <el-radio :label='60'>60V</el-radio>
          <el-radio :label='72'>72V</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Replaceable battery material') }}</div>
      <div class="row-right">
        <el-checkbox-group v-model="supportMaterialTypeList">
          <el-checkbox v-for="(item, index) in materialTypeList" :key="index" :label="item.key"
                       :checked="item.checked">{{ $t('lang.' + item.value) }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Battery collection conditions') }}</div>
      <div class="row-right">
        <div style="display: inline-block; width: 180px">
          {{ $t('lang.The actual replaceable battery in the cabinet is not less than') }}
        </div>
        <el-input v-model="minSwapBatteryQuantity" style="width: 70px"
                  clearable maxlength="50"></el-input>
      </div>
    </div>

    <div class="row">
      <div class="label">{{ $t('lang.Return of battery conditions') }}</div>
      <div class="row-right">
        <div style="display: inline-block; width: 180px">{{ $t('lang.There should be no less space in the cabinet') }}
        </div>
        <el-input v-model="minEmptyPortQuantity" style="width: 70px"
                  clearable maxlength="50"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Business hours') }}</div>
      <div class="row-right">
        <el-time-select
          v-model="deviceInfo.serviceStartTime0"
          default-value=""
          :picker-options="{
                        start: '00:00',
                        step: '00:15',
                        end: '24:00'
                    }"
          :placeholder="$t('lang.start time')">
        </el-time-select>
        -
        <el-time-select
          default-value=""
          v-model="deviceInfo.serviceStopTime0"
          :picker-options="{
                        start: '00:00',
                        step: '00:15',
                        end: '24:00'
                    }"
          :placeholder="$t('lang.end time')">
        </el-time-select>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Real picture') }}</div>
      <div class="row-right">
        <el-upload
          :class="{disUoloadSty:hideUpload}"
          :file-list="fileList"
          :limit="limitCount"
          action="#"
          :on-change="uploadHandle"
          list-type="picture-card"
          :auto-upload="false">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url" alt=""
            >
            <span class="el-upload-list__item-actions">
                            <span
                              @click="handleRemove(file)"
                              v-if="!disabled"
                              class="el-upload-list__item-delete"
                            >
                            <i class="el-icon-delete"></i>
                            </span>
                        </span>
          </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </div>
    </div>
    <!--        <div class="row">
                <div class="label">{{$t('lang.Number of replaceable batteries')}}</div>
                <div class="row-right">
                    <el-input class="fixed-width-200" type="text" v-model="deviceInfo.swapBatteryQuantity"
                     clearable maxlength="50"></el-input>
                </div>
            </div>-->
    <div class="row">
      <span style="color:red">*</span>
      <div class="label">{{ $t('lang.Equipment version') }}</div>
      <div class="row-right">
        <el-select v-model="deviceInfo.version" clearable>
          <el-option
            v-for="item in versionList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <span style="color:red">*</span>
      <div class="label">{{ $t('lang.Protocol version') }}</div>
      <div class="row-right">
        <el-select v-model="deviceInfo.agreementVersion" clearable>
          <el-option
            v-for="item in agreementVersionList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="label">{{ $t('lang.Equipment status') }}</div>
      <div class="row-right">
        {{
          deviceInfo.enableStatus == 1 ? $t('lang.Enable') : (deviceInfo.enableStatus == 0 ? $t('lang.unenable') : '')
        }}
      </div>
      <div class="row-right ml10" style="color: #67aa42;" @click="changeStatus">{{ $t('lang.Switch state') }}</div>
    </div>
    <div class="row">
      <div class="normal-btn" @click="cancel">{{ $t('lang.Cancel') }}</div>
      <div class="blue-btn" @click="confirm">{{ $t('lang.Confirm') }}</div>
    </div>
  </div>
</template>
<script>
import {MATERIAL_TYPE} from "@/utils/constant";
import Utils from "../../utils/utils";
import {queryDevicePicture} from '@/api/deviceManagement'

export default {
  name: 'batterySwapMgmtEditView',
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    let self = this;
    return {
      googleSearch: '',
      position: {lng: 120.5, lat: 30.2},
      hideUpload: true,
      limitCount: 3,
      editFlag: true,
      onceFlag: true,
      // fileArr:[],//回显用
      picForm: {
        picture1: '',
        picture1Name: '',
        picture2: '',
        picture2Name: '',
        picture3: '',
        picture3Name: '',
      },
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      dialogFormVisible: false,
      deviceInfo: {
        serviceStopTime0: '',
        serviceStartTime0: ''
      },
      primaryDeviceNo: '',
      placingPosition: [],
      detailAddress: '',
      searchOption: {
        city: "全国",
        citylimit: true
      },
      zoom: 12,
      center: {lng: 120.15, lat: 30.28},
      // center: [120.15, 30.28],
      markers: [],
      address: '',
      // events: {
      //     click(e) {
      //         let {lng, lat} = e.lnglat;
      //         self.lng = lng;
      //         self.lat = lat;
      //         self.addMarker(lng, lat);
      //         // 这里通过高德 SDK 完成。
      //         var geocoder = new AMap.Geocoder({
      //             radius: 1000,
      //             extensions: "all"
      //         });
      //         geocoder.getAddress([lng, lat], function (status, result) {
      //             if (status === 'complete' && result.info === 'OK') {
      //                 if (result && result.regeocode) {
      //                     self.address = result.regeocode.formattedAddress;
      //                     self.$nextTick();
      //                 }
      //             }
      //         });
      //     }
      // },
      lng: 0,
      lat: 0,
      qrCode: '',
      supportBatteryVoltageList: '',
      supportMaterialTypeList: [],
      materialTypeList: [],
      swapBatteryQuantity: "",
      versionList: [
        {
          id: "-999",
          name: this.$t('lang.unselected')
        },
        {
          id: "1",
          name: "v1.0"
        },
        {
          id: "2",
          name: "v2.0"
        }
      ],
      agreementVersionList: [
        {
          id: "-999",
          name: this.$t('lang.unselected')
        },
        {
          id: "1",
          name: "v1.0"
        },
        {
          id: "2",
          name: "v2.0"
        },
        {
          id: "3",
          name: "v3.0"
        }
      ],
      minSwapBatteryQuantity: '2',
      minEmptyPortQuantity: '2'
    };
  },
  watch: {
    editData: {
      handler() {
        console.log(this.editData, 'deviceInfo1');
        this.deviceInfo = this.editData;
        if (this.deviceInfo.editPlacingPosition) {
          this.placingPosition[0] = this.deviceInfo.editPlacingPosition.province;
          this.placingPosition[1] = this.deviceInfo.editPlacingPosition.city;
          this.placingPosition[2] = this.deviceInfo.editPlacingPosition.district;
          this.detailAddress = this.deviceInfo.editPlacingPosition.addressDetail;
        }
        this.supportBatteryVoltageList = this.deviceInfo.supportBatteryVoltageList ? JSON.parse(this.deviceInfo.supportBatteryVoltageList)[0] : ''
        this.materialTypeList = this.deviceInfo.supportBatteryMaterialTypeList;
        this.swapBatteryQuantity = this.deviceInfo.swapBatteryQuantity ? this.deviceInfo.swapBatteryQuantity + '' : '';
        this.minEmptyPortQuantity = this.deviceInfo.minEmptyPortQuantity || '2';
        this.minSwapBatteryQuantity = this.deviceInfo.minSwapBatteryQuantity || '2';
        this.queryDevicePicture();
      },
      deep: true,
    },
  },
  mounted() {

  },
  methods: {
    // 谷歌搜索按钮
    googleChange(val) {
      const rep = fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${this.address}&key=AIzaSyBhL1KdJ-3jGM5T6qJ8pvD4BWd6gxvS40I`);
      rep.then(resp => {
        resp.json().then(res => {
          console.log(res.results[0].address_components, '谷歌');
          console.log(res.results[0].geometry.location, 'location');
          this.center.lng = res.results[0].geometry.location.lng;
          this.center.lat = res.results[0].geometry.location.lat;
          console.log(this.center, 'center11');
        })
      })
    },
    // 点地图
    events(e) {
      console.log(e, 'e3333');
      this.position = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      }
      const rep = fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.position.lat},${this.position.lng}&location_type=ROOFTOP&result_type=street_address&key=AIzaSyBhL1KdJ-3jGM5T6qJ8pvD4BWd6gxvS40I`);
      rep.then(resp => {
        resp.json().then(res => {
          console.log(res, '谷歌res');
          // console.log(res.results[0].formatted_address,'谷歌');
          this.address = res.results.length === 0 ? res.plus_code.compound_code : res.results[0].formatted_address;

        })
      })

    },
    // 编辑图片回显
    async queryDevicePicture() {
      if (this.onceFlag) {
        this.onceFlag = false;
        const params = {
          primaryDeviceNo: this.editData.primaryDeviceNo,
        };
        try {
          const res = await queryDevicePicture(params);
          const picData = res.mdata;
          if (picData.picture1) {
            this.fileList.push({url: picData.picture1, name: picData.picture1Name});
          }
          if (picData.picture2) {
            this.fileList.push({url: picData.picture2, name: picData.picture2Name});
          }
          if (picData.picture3) {
            this.fileList.push({url: picData.picture3, name: picData.picture3Name});
          }
        } catch (e) {
          console.log(e);
        }
      }

    },
    // 图片改变
    uploadHandle(file, fileList) {
      this.fileList = fileList;
      this.hideUpload = this.fileList.length >= this.limitCount;
    },
    // 转base64
    uploadImg() {
      let AllowImgFileSize = 2100000; //上传图片最大值(单位字节)（ 2 M = 2097152 B ）超过2M上传失败
      if (this.fileList.length === 0) {
        this.addOrEditDevice();
        return;
      }
      console.log(this.fileList, 'fileList1');
      this.fileList.forEach((el, i) => {
        if (!el.size) {
          this.picForm[`picture${i + 1}`] = el.url;
          this.picForm[`picture${i + 1}Name`] = el.name;
          return;
        }
        if (el.raw) {
          let f = el.raw;
          var reader = new FileReader();
          reader.readAsDataURL(f);
          let self = this;
          reader.onloadend = () => {
            if (AllowImgFileSize != 0 && AllowImgFileSize < reader.result.length) {
              alert(self.$t('lang.Please upload pictures below 2m'))
            } else {
              self.picForm[`picture${i + 1}`] = reader.result;
              self.picForm[`picture${i + 1}Name`] = el.name;
            }
          }
        }
      })
      setTimeout(() => {
        this.addOrEditDevice();
      }, 300);
    },
    // 删除图片
    handleRemove(file) {
      console.log(file);
      this.fileList.forEach((el, i) => {
        if (file.uid == el.uid) {
          this.fileList.splice(i, i + 1)
        }
      });
      this.hideUpload = this.fileList.length >= this.limitCount;
      console.log(this.fileList, 'removefileList');
    },
    onSearchResult(pois) {
      let self = this;
      let latSum = 0;
      let lngSum = 0;
      if (pois.length > 0) {
        pois.forEach(poi => {
          let {lng, lat} = poi;
          lngSum += lng;
          latSum += lat;
        });
        let center = {
          lng: lngSum / pois.length,
          lat: latSum / pois.length
        };
        this.center = {lng: center.lng, lat: center.lat},
          this.addMarker(center.lng, center.lat);
        var geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: "all"
        });
        geocoder.getAddress([center.lng, center.lat], function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            if (result && result.regeocode) {
              self.address = result.regeocode.formattedAddress;
              self.$nextTick();
            }
          }
        });
      }
    },
    addMarker(lng, lat) {
      let marker = {
        position: [lng, lat],
        visible: true,
        draggable: false,
        template: '<span>1</span>'
      };
      this.markers[0] = marker;
    },
    cancelChoose() {
      this.center = [120.15, 30.28];
      this.address = '';
      this.dialogFormVisible = false;
    },
    // 地图确认按钮
    confirmChoose() {
      let area = Utils.getArea(this.address);
      console.log(area, 'area111');
      if (area) {
        this.placingPosition[0] = area.Province;
        this.placingPosition[1] = area.City;
        this.placingPosition[2] = area.Country;
        this.detailAddress = area.Address;
      }
      console.log(this.placingPosition, this.detailAddress, 'this.detailAddress11');
      this.dialogFormVisible = false;
    },
    // 确认按钮验证
    confirm() {
      if (!this.deviceInfo.deviceName) {
        this.$message.error(this.$t('lang.Please enter the equipment name'));
        return;
      }
      if (this.placingPosition.length == 0) {
        this.$message.error(this.$t('lang.Please enter the delivery address'));
        return;
      }
      if(this.deviceInfo.enableStatus == 1) {
        if(!this.detailAddress) {
          this.$message.error(this.$t('lang.Please enter the detail address'));
          return;
        }
      }
      if (!this.supportBatteryVoltageList) {
        this.$message.error(this.$t('lang.Please select a replaceable battery specification'));
        return;
      }
      if (!this.deviceInfo.version) {
        this.$message.error(this.$t('lang.Please select the equipment version'));
        return;
      }
      if (!this.deviceInfo.agreementVersion) {
        this.$message.error(this.$t('lang.Please select the protocol version'));
        return;
      }
      this.uploadImg();
    },
    cancel() {
      this.$emit('cancel');
    },


    // 确定按钮
    addOrEditDevice() {
      if (!this.editFlag) {
        return;
      }
      this.editFlag = false;
      let serviceStartTime = Utils.timeStamp(this.deviceInfo.serviceStartTime0);
      let serviceStopTime = Utils.timeStamp(this.deviceInfo.serviceStopTime0);
      if (!serviceStartTime && +serviceStartTime != 0) {
        serviceStartTime = null;
      }
      if (!serviceStopTime) {
        serviceStopTime = null;
      }
      let self = this;
      let reg = /^[1-9]\d*$/;
      if (this.swapBatteryQuantity) {
        if (!this.swapBatteryQuantity.match(reg)) {
          self.$message({
            type: "warning",
            message: self.$t('lang.The number of exchangeable batteries is illegal'),
            center: true
          });
          return;
        }
      }
      let placingPosition = {};
      if (this.placingPosition.length > 0) {
        placingPosition.province = this.placingPosition[0];
        placingPosition.city = this.placingPosition[1];
        placingPosition.district = this.placingPosition[2];
      } else {
        placingPosition.province = '';
        placingPosition.city = '';
        placingPosition.district = '';
      }
      placingPosition.addressDetail = this.detailAddress;
      let params = {
        ...this.picForm,
        serviceStartTime,
        serviceStopTime,
        swapBatteryQuantity: this.swapBatteryQuantity,
        primaryDeviceNo: this.deviceInfo.primaryDeviceNo,
        placingPosition: JSON.stringify(placingPosition),
        deviceName: this.deviceInfo.deviceName,
        version: this.deviceInfo.version,
        agreementVersion: this.deviceInfo.agreementVersion,
        supportBatteryVoltageList: JSON.stringify([this.supportBatteryVoltageList]),
        supportBatteryMaterialType: JSON.stringify(this.supportMaterialTypeList),
        locationLongitude: this.position.lng || this.deviceInfo.locationLongitude,
        locationLatitude: this.position.lat || this.deviceInfo.locationLatitude,
        minEmptyPortQuantity: this.minEmptyPortQuantity,
        minSwapBatteryQuantity: this.minSwapBatteryQuantity,
      };
      this.$http.post('/managementPlatform/electricity/editPrimaryDeviceInfo', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: self.$t('lang.Successful'),
          center: true
        });
        self.$emit('editSuccess');
      }).catch(function (response) {
        console.log(response);
      });
      setTimeout(() => {
        this.editFlag = true;
      }, 1000);
    },
    bindQrcode(file) {
      let url = URL.createObjectURL(file.raw);
      this.$qrcode.decodeFromImage(url).then((res) => {
        this.qrCode = Utils.getQueryParam(res.data, 'qrcode');
        this.bindQrCodeToDevice();
      });
    },
    bindQrCodeToDevice() {
      let self = this;
      let params = {
        cabinetNo: this.deviceInfo.primaryDeviceNo,
        qrcode: this.qrCode,
        reconfirm: 0
      };
      this.$http.post('/managementPlatform/electricity/bindQRCode', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        if (res.mdata.needReconfirm == 1) {
          self.$confirm(res.mdata.msg, '', {
            confirmButtonText: self.$t('lang.Confirm'),
            cancelButtonText: self.$t('lang.Cancel'),
            type: 'warning'
          }).then(() => {
            self.reconfirm = 1;
            self.bindQrCodeToDevice();
          }).catch(action => {
          });
        } else {
          self.$message({
            type: "success",
            message: self.$t('lang.Successful'),
            center: true
          });
          self.deviceInfo.qrcodeBindStatus = '1';
        }
      }).catch(function (response) {
        console.log(response);
      });
    },
    changeStatus() {
      let self = this;
      if (this.deviceInfo.enableStatus == 1) {
        this.$confirm(this.$t('lang.Make sure to deactivate the equipment'), '', {
          confirmButtonText: self.$t('lang.Confirm'),
          cancelButtonText: self.$t('lang.Cancel'),
          type: 'warning'
        }).then(() => {
          self.changeDeviceStatus(0);
        }).catch(action => {
        });
      } else {
        this.$confirm(this.$t('lang.Determine the device'), '', {
          confirmButtonText: self.$t('lang.Confirm'),
          cancelButtonText: self.$t('lang.Cancel'),
          type: 'warning'
        }).then(() => {
          self.changeDeviceStatus(1);
        }).catch(action => {
        });
      }
    },
    changeDeviceStatus(status) {
      let self = this;
      let params = {
        primaryDeviceNo: this.deviceInfo.primaryDeviceNo,
        enableStatus: status
      };
      this.$http.post('/managementPlatform/electricity/editPrimaryDeviceEnableStatus', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: self.$t('lang.Successful'),
          center: true
        });
        self.deviceInfo.enableStatus = status;
      }).catch(function (response) {
        console.log(response);
      });
    }
  },
}
</script>
<style lang="scss" scoped>
.row {
  margin: 20px 0 0 20px;
  font-size: 14px;

  .fixed-width {
    width: 240px;
  }

  .row-right {
    display: inline-block;
    line-height: 30px;

    .top {
      vertical-align: top;
      color: #999999;
    }
  }

  .label {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    min-width: 100px;
    margin-right: 14px;
    line-height: 25px;
  }

  .blue-btn {
    margin-right: 10px;
  }

  .table-custom {
    width: 920px;
  }

  .fixed-width-200 {
    width: 200px;
    vertical-align: top;
  }

  .fixed-width-350 {
    width: 350px;
    vertical-align: top;
  }

  .fixed-width-450 {
    width: 450px;
    vertical-align: top;
  }

  .btn {
    cursor: pointer;
  }

  .icon {
    color: #67aa42;
    font-size: 20px;
  }
}

.amap-demo {
  height: 300px;
  margin: 20px 0;
}

.inpPadding {
  padding: 0px;
}

.disUoloadSty /deep/ .el-uploadel-upload--picture-card {
  display: none; /* 上传按钮隐藏 */
}

.googleInp {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/batterySwapMgmtEditView.vue